var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12 23V1","stroke":"#130F26","stroke-width":"2","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M0.999999 12L23 12","stroke":"#130F26","stroke-width":"2","stroke-linecap":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }